<template>
	<button
		class="
            flex-center gap-1 rounded border border-won-green px-3 py-1.5 text-base
            text-won-green disabled:cursor-not-allowed disabled:border-[#C2C4C6]
            disabled:text-[#C2C4C6]
        "
		:disabled="disabled"
		@click="copyShareLinkHandler"
	>
		<LinkIcon
			:class="buttonSize"
		/>

		<span>Copy Link</span>
	</button>
</template>

<script setup>
import { LinkIcon } from '@heroicons/vue/24/outline';
import { useResumeShare } from '../../store/share-resume.store';

defineProps({
	disabled: {
		type: Boolean,
		default: true
	},
	buttonSize: {
		type: String,
		default: 'size-6'
	}
});

const shareResumeStore = useResumeShare();

const copyShareLinkHandler = () => {
	shareResumeStore.copyLinkHandler(); 
};
</script>
